import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { ProfileAvatarComponent } from '../../profile-avatar/profile-avatar.component';
import { BreadcrumbComponent } from '../../breadcrumbs/breadcrumbs.component';
import {
  CommandPaletteService,
  isApplePlatform,
} from '../../command-palette/command-palette.service';

@Component({
  selector: 'app-top-navbar',
  standalone: true,
  imports: [ProfileAvatarComponent, BreadcrumbComponent],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.css',
})
export class TopNavbarComponent implements OnInit {
  private palette = inject(CommandPaletteService);

  /** Whether the rail is open as a drawer (below lg), for the menu button's state. */
  @Input() menuOpen = false;
  @Output() menuClick = new EventEmitter<void>();
  @Output() profileOptionsChange = new EventEmitter<boolean>();

  /** The palette key as this keyboard prints it; the server renders Ctrl. */
  isApple = false;

  ngOnInit() {
    this.isApple = isApplePlatform();
  }

  openSearch() {
    this.palette.openPalette();
  }

  handleMenuClick() {
    this.menuClick.emit();
  }

  handleProfileOptionsChange(isOpen: boolean) {
    this.profileOptionsChange.emit(isOpen);
  }
}
